import { useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { AppSettings } from "../../config/app-settings.js";
import Preloader from "../../components/custom/preLoader";
import showErrorToast from "../../components/toast/toast";
import { setAuthTokens } from "../../components/content/axiosConfig.js";
import { clearStashedCompanySession } from "../../utils/companyHandoff.js";
import { clearScopedAccount, setScopedAccount } from "../../utils/accountContext.js";

const AdminHandoff = () => {
  const context = useContext(AppSettings);
  const history = useHistory();

  useEffect(() => {
    const { handleSetAppSidebarNone, handleSetAppHeaderNone, handleSetAppContentClass } = context;
    handleSetAppSidebarNone(true);
    handleSetAppHeaderNone(true);
    handleSetAppContentClass("p-0");
  }, [context]);

  useEffect(() => {
    const hash = window.location.hash.slice(1);
    if (!hash) {
      showErrorToast("Invalid login link");
      history.replace("/user/login");
      return;
    }

    try {
      const data = JSON.parse(decodeURIComponent(hash));
      if (!data?.token || !data?.User) {
        throw new Error("Missing session data");
      }
      const isCompany = !!(data.User?.isCompanyManager || data.User?.IsCompanyManager);
      const isSuper = !!(data.User?.isSuperUser || data.User?.IsSuperUser);
      if (isCompany) {
        clearStashedCompanySession();
      }
      setAuthTokens(data.token, data.refreshToken, data.User);

      if (data.accountId != null && (isSuper || isCompany)) {
        setScopedAccount({
          id: data.accountId,
          name: data.accountName || null,
          email: data.accountEmail || null,
        });
        window.location.hash = "";
        window.location.replace("/dashboard");
        return;
      }

      clearScopedAccount();
      window.location.hash = "";
      window.location.replace(isCompany ? "/company/accounts" : "/dashboard");
    } catch (error) {
      console.error("Admin handoff failed:", error);
      showErrorToast("Could not sign in to the Admin panel");
      history.replace("/user/login");
    }
  }, [history]);

  return <Preloader />;
};

export default AdminHandoff;
